<template>
    <div>
        <Modal v-model="isShowModal" :title="title" @on-cancel="hide()" :mask-closable="false" width="950">

            <Divider orientation="left">订单信息</Divider>
          <Row :gutter="16">
            <Col span="8">
              <div>订单编号：{{ orderInfo.recoveryOrder.orderCode }}</div>
            </Col>
            <Col span="8">
              <div>订单标题：{{ orderInfo.recoveryOrder.orderTitle }}</div>
            </Col>
            <Col span="8">
            </Col>
            <Col span="8">
              <div>下单昵称：{{ orderInfo.recoveryOrder.nickName }}</div>
            </Col>
          </Row>
<!--          <Row :gutter="16">-->
<!--            <Col span="8">-->
<!--              <div>订单总额：{{ orderInfo.recoveryOrder.totalAmount ? '￥' + orderInfo.recoveryOrder.totalAmount : '-' }}-->
<!--              </div>-->
<!--            </Col>-->
<!--            <Col span="8">-->
<!--              <div>-->
<!--                总重量：{{orderInfo.recoveryOrder.totalWeight ? orderInfo.recoveryOrder.totalWeight + '公斤' : '-'}}-->
<!--              </div>-->
<!--            </Col>-->
<!--            <Col span="8">-->
<!--              <div>赠送积分：{{ orderInfo.recoveryOrder.integral ? orderInfo.recoveryOrder.integral : '-' }}</div>-->
<!--            </Col>-->
<!--          </Row>-->
          <Row :gutter="16">
            <Col span="8">
              <div>创建时间：{{ orderInfo.recoveryOrder.createTime }}</div>
            </Col>
            <Col span="8">
              <div>取消时间：{{ orderInfo.recoveryOrder.cancelTime ?  orderInfo.recoveryOrder.cancelTime : '-'}}</div>
            </Col>
            <Col span="8">
              <div>
                订单状态：
                <template v-if="orderInfo.recoveryOrder.orderState == 1">待确认</template>
                <template v-if="orderInfo.recoveryOrder.orderState == 2">待回收</template>
                <template v-if="orderInfo.recoveryOrder.orderState == 3">运输中</template>
                <template v-if="orderInfo.recoveryOrder.orderState == 4">待验收</template>
                <template v-if="orderInfo.recoveryOrder.orderState == 5">已完成</template>
                <template v-if="orderInfo.recoveryOrder.orderState == 6">已取消</template>
                <template v-if="orderInfo.recoveryOrder.orderState == 7">揽件失败</template>
              </div>
            </Col>
          </Row>
          <Row :gutter="16">
            <Col span="8">
              <div>
                预估重量：{{
                  orderInfo.recoveryOrder.estimateWeight ? orderInfo.recoveryOrder.estimateWeight : '-'
                }}
              </div>
            </Col>
            <Col span="8">
              <div>
                快递反馈重量：{{
                  orderInfo.orderLogistics && orderInfo.orderLogistics.expressWeight ? orderInfo.orderLogistics.expressWeight : '-'
                }}KG
              </div>
            </Col>
            <Col span="8">
              <div>
                订单备注：{{
                  orderInfo.recoveryOrder.remark ? orderInfo.recoveryOrder.remark : '-'
                }}
              </div>
            </Col>
          </Row>
          <Row :gutter="16">
            <Col span="8">
              <div>用户上传图片：
                <div class="" style="margin-right: 10px"  v-for="(v,i) in formatImage(orderInfo.recoveryOrder.userImg)"
                     :key="i" @click="previewImage(formatImage(orderInfo.recoveryOrder.userImg))">
                  <img :src="v" style="width: 100px; height: 100px;">
                </div>
              </div>
            </Col>
          </Row>
<!--          <Divider orientation="left">回收地址</Divider>-->
<!--          <Row :gutter="16">-->
<!--            <Col span="8">-->
<!--              <div >用户姓名：{{ orderInfo.address.realName }}</div>-->
<!--            </Col>-->
<!--            <Col span="8">-->
<!--              <div>用户手机号：{{ orderInfo.address && orderInfo.address.mobile ? orderInfo.address.mobile : '-' }}</div>-->
<!--            </Col>-->
<!--          </Row>-->
<!--          <Row>-->
<!--            <Col span="24">-->
<!--              <div>用户地址：{{ orderInfo.address && orderInfo.address.locationAddress }} {{ orderInfo.address && orderInfo.address.address }}</div>-->
<!--            </Col>-->
<!--          </Row>-->

          <Divider orientation="left">质检信息</Divider>
          <Row>
            <Col span="24">
              <div style="margin-left: 110px; margin-bottom: 10px">
                质检结果：
                <RadioGroup v-model="isPass">
                  <Radio :label="1">合格</Radio>
                  <Radio :label="0">不合格</Radio>
                </RadioGroup>
              </div>
            </Col>
          </Row>
          <Row v-for="(item,index) in orderInfo.recoveryOrderItem" :key="index">
            <Col span="9" style="margin-top: 10px">
              <div class="j-order-image">
                <div class="j-order-image-main">
                  <img :src="item.categoryImage">
                </div>
                <div class="j-order-image-info">
                  <div class="j-order-goods-title">
                    <span class="category-name">{{ item.categoryName }}</span>
                    <Select v-model="item.lowerCategoryId" placeholder="回收品类" clearable style="width: 160px" @on-change="handleCategoryChange($event, index)">
                      <Option v-for="(itemCategory, index) in categoryList" :value="itemCategory.categoryId" :key="index">{{ itemCategory.name }}</Option>
                    </Select>
                  </div>
                  <div class="j-order-goods-price" v-show="isPass === 1">
                    回收单价：
                    <InputNumber v-model="item.unitPrice" :min="0" :precision="3" :active-change="false" @on-blur="unitPriceVer(index)" style="width: 90px"/>元
                  </div>
                  <div class="j-order-goods-price" v-show="isPass === 1">
                    回收{{item.categoryUnit === 1 ? '重量' : '数量'}}：
                    <InputNumber v-model="item.weight" :min="0" :precision="1" :active-change="false" @on-blur="weightVer(item, index)" style="width: 90px"/>
                    {{item.categoryUnit === 1 ? '公斤' : '个'}}
                  </div>
                  <div class="j-order-goods-price" v-show="isPass === 1">
                    金额：{{orderInfo.recoveryOrder.totalAmount}}
                  </div>
                </div>
              </div>
            </Col>
            <Col span="15">
              <div class="demo-upload-list"  v-for="(v,i) in formatImage(item.orderImage)">
                <template>
                  <img :src="v">
                  <div class="demo-upload-list-cover">
                    <Icon type="ios-eye-outline" @click.native="previewImage(formatImage(item.orderImage))"></Icon>
                    <Icon type="ios-trash-outline" @click.native="handleRemove(item.orderImage, index)"></Icon>
                  </div>
                </template>
              </div>

              <Upload
                  ref="upload"
                  :show-upload-list="false"
                  :on-success="(value)=> handleSuccess(index, value)"
                  :format="['jpg','jpeg','png']"
                  :max-size="6144"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload"
                  multiple
                  type="drag"
                  :action="action"
                  :headers="headers"
                  style="display: inline-block;width:58px;">
                <div style="width: 58px;height:58px;line-height: 58px;">
                  <Icon type="ios-camera" size="20"></Icon>
                </div>
              </Upload>
            </Col>
          </Row>

          <!-- 图片预览弹窗 -->
          <viewer :images="images" class="viewer" ref="viewer" @inited="inited" v-show="showImage">
            <template scope="scope">
              <img v-for="src in scope.images" :src="src+`?${Date.now}`" :key="src">
              {{ scope.options }}
            </template>
          </viewer>
            <!-- 重写对话框底部按钮 -->
            <div slot="footer">
                <Button @click="hide('formValidate')">取消</Button>
                <Button type="primary" @click="passOrder()" :loading="loadingBtn">
                    <span v-if="!loadingBtn">保存</span>
                    <span v-else>请稍候...</span>
                </Button>
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
          action: this.$uploadURL,
          headers: {
            token: JSON.parse(sessionStorage.getItem('J-TOKEN')).token
          },
            isShowModal: false,
            loadingBtn: false,
            orderInfo: {
                recoveryOrder: {},
                address: {},
                recoveryOrderItem: []
            },
            title: '订单质检',
            images: [],
            showImage: false,
            warehouseList: [],
            expressList: [
              {
                value: 1,
                label: '德邦快递',
              }
            ],
            deliveryAddressId: '',
            recoveryOrderId: '',
            expressType: '',
            params: {
              page: 1,
              rows: 20,
              isDisable: 0,
            },
          uploadList: [],
          categoryList: [],
          categoryId: '',
          expressWeight: '',
          isPass: 1
        }
    },
    methods: {
        // 显示模态框
        show(row) {
            this.isShowModal = true;
            this.getInfo(row);

        },
        // 查询订单详情
        getInfo(row) {
            this.$Spin.show();
            this.axios.post('/recoveryOrder/getInfo', {
                recoveryOrderId: row.recoveryOrderId
            }).then(res => {
                console.log(res);
                this.recoveryOrderId = row.recoveryOrderId
                setTimeout(() => {
                    this.$Spin.hide();
                }, 300);
                if (res.status == 200) {
                    // this.$Message.success('操作成功.');
                    this.orderInfo = res.data;
                    this.categoryId = res.data.recoveryOrderItem[0].categoryId
                    if (res.data.orderLogistics && res.data.orderLogistics.expressWeight) {
                      this.expressWeight = res.data.orderLogistics.expressWeight
                    }
                    this.findCategoryByParentId();
                }
                if (res.status == 500) {
                    this.$Notice.error({
                        title: '服务器内部错误',
                        desc: '查看订单详情接口报错',
                        duration: 0
                    });
                }
            })
        },
      findCategoryByParentId() {
        this.axios.post('/recoveryCategory/findSecondListByParentId', {
          parentId: this.categoryId
        }).then(res => {
          console.log(res);
          if (res.status == 200) {
            // this.$Message.success('操作成功.');
            this.categoryList = res.data;
          }
          if (res.status == 500) {
            this.$Notice.error({
              title: '服务器内部错误',
              desc: '查看订单详情接口报错',
              duration: 0
            });
          }
        })
      },
        // 关闭模态框
        hide() {
            this.isShowModal = false;
        },
        // 质检
        passOrder() {
          if (this.isPass === '') {
            this.$Message.success('请选择质检结果.');
            return;
          }

          this.axios.post('/recoveryOrder/passOrder', {
            'recoveryOrderId': this.recoveryOrderId,
            'categoryArray': this.orderInfo.recoveryOrderItem,
            'isPass': this.isPass
          }).then(res => {
            if (res.status == 200) {
              this.$emit('changeDate');
              this.$Message.success('操作成功.');
              this.hide('formValidate');
            }
            if(res.status == 201){
              this.$Message.error(res.msg);
            }
            if (res.status == 500) {
              this.$Notice.error({
                title: '服务器内部错误',
                desc: '派单接口报错',
                duration: 0
              });
            }
          })
        },
      // 选择分类后回显价格
      handleCategoryChange(categoryId, index) {
        if (categoryId) {
          const category = this.categoryList.find(item => item.categoryId === categoryId);
          if (category && category.priceMax !== undefined) {
            this.orderInfo.recoveryOrderItem[index].unitPrice = category.priceMax;
            this.orderInfo.recoveryOrderItem[index].weight = this.expressWeight
            // 触发金额计算
            this.unitPriceVer(index);
          }
        }
      },
      // 回收仓库-列表查询
      findList() {
          this.axios.post('/warehouse/findList', this.params).then(res => {
            if (res.status == 200) {
              this.total = res.data.total;
              this.data = res.data.rows;
              if (this.data) {
                this.warehouseList = []
                this.data.forEach(v => {
                  let object = {
                    value: v.warehouseId,
                    label: v.warehouseName
                  }
                  this.warehouseList.push(object)
                })
              }
            }
            if (res.status == 500) {
              this.$Notice.error({
                title: '服务器内部错误',
                desc: '查询回收员列表接口报错',
                duration: 0
              });
            }
          })
        },
      unitPriceVer(index) {
        if (!this.orderInfo.recoveryOrderItem[index].unitPrice) {
          this.$Message.error('还有信息没有填写合格哦~');
          return
        }
        let totalAmount = 0;
        this.orderInfo.recoveryOrderItem.forEach(item => {
          let amount = item.unitPrice * item.weight
          amount = Math.floor(amount * 10) / 10
          totalAmount = totalAmount + amount
        })
        console.log('totalAmount', Math.floor(totalAmount * 10) / 10)
        this.orderInfo.recoveryOrder.totalAmount = Math.floor(totalAmount * 10) / 10
      },
      weightVer(item, index) {
        if (!this.orderInfo.recoveryOrderItem[index].weight) {
          this.$Message.error('还有信息没有填写合格哦~');
          return
        }
        // let cutWeight = this.orderInfo.recoveryOrderItem[index].weight * this.orderInfo.recoveryOrderItem[index].ratio
        // console.log('cutWeight', Math.floor(cutWeight * 10) / 10);
        // let totalWeight = parseFloat(this.orderInfo.recoveryOrderItem[index].weight) + cutWeight
        // console.log('totalWeight--', Math.floor(totalWeight * 10) / 10);
        // this.orderInfo.recoveryOrderItem[index].cutWeight = Math.floor(cutWeight * 10) / 10
        // this.orderInfo.recoveryOrderItem[index].totalWeight = Math.floor(totalWeight * 10) / 10
        this.unitPriceVer(index);
      },
      inited(viewer) {
        this.$viewer = viewer
      },
      previewImage(images) {
        this.images = images;
        this.$viewer.show();
      },
      // 格式化图片
      formatImage(image) {
        if (image) {
          return image.split(',')
        }
      },
      // 从 upload 实例删除数据
      handleRemove (imgUrl, index) {
        // 转为数组
        let imgArr = this.orderInfo.recoveryOrderItem[index].orderImage.split(",");
        // 删除url
        imgArr.splice(imgArr.indexOf(imgUrl), 1)
        // 数组再次转为字符串
        this.orderInfo.recoveryOrderItem[index].orderImage = imgArr.join(",");
      },
      handleSuccess (index, value) {
          console.log('11111', index, value)
        if (this.orderInfo.recoveryOrderItem[index].orderImage && this.orderInfo.recoveryOrderItem[index].orderImage !== '') {
          // 转为数组
          let imgArr = this.orderInfo.recoveryOrderItem[index].orderImage.split(",");
          // 插入url
          imgArr.push(value.data)
          // 数组再次转为字符串
          this.orderInfo.recoveryOrderItem[index].orderImage = imgArr.join(",");
        } else {
          this.orderInfo.recoveryOrderItem[index].orderImage = value.data
        }
      },
      handleFormatError (file) {
        this.$Notice.warning({
          title: '文件格式不正确',
          desc: '文件 ' + file.name + ' 格式不正确，请上传 jpg 或 png 格式的图片。'
        });
      },
      handleMaxSize (file) {
        this.$Notice.warning({
          title: '超出文件大小限制',
          desc: '文件 ' + file.name + ' 太大，不能超过 6M。'
        });
      },
      handleBeforeUpload () {
        const check = this.uploadList.length < 8;
        if (!check) {
          this.$Notice.warning({
            title: '最多只能上传 8 张图片。'
          });
        }
        return check;
      }
    }
}
</script>

<style scoped lang="less">
.j-order-image {
    display: flex;

    .j-order-image-main {
        width: 100px;
        height: 100px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .j-order-image-info {
        margin-left: 10px;

        .j-order-goods-title {
            display: flex;
            align-items: center;
            
            .category-name {
                white-space: nowrap;
                margin-right: 10px;
                font-weight: bold;
            }
        }

        .j-order-goods-sku {
            margin-top: 5px;
        }

        .j-order-goods-price {
            margin-top: 5px;
        }

        .j-order-goods-num {
            margin-top: 5px;
        }
    }
}

.demo-upload-list{
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0,0,0,.2);
  margin-right: 4px;
}
.demo-upload-list img{
  width: 100%;
  height: 100%;
}
.demo-upload-list-cover{
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0,0,0,.6);
}
.demo-upload-list:hover .demo-upload-list-cover{
  display: block;
}
.demo-upload-list-cover i{
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}


</style>